// extracted by mini-css-extract-plugin
export default {"container":"Theme_container__CouYg","icon":"Theme_icon__iSDpK"};